import {
  createFileRoute,
  useNavigate,
  useSearch,
} from '@tanstack/react-router';
import { CategoryForm } from '@/pages/preferences/tabs/categories/form';
import { PROTECTED, SETTINGS } from '@/lib/constants/routes';
import { useCategoryDetail } from '@/api/category/use-category-detail';

export const Route = createFileRoute(
  '/protected/_layout/settings/_layout/categories/new'
)({
  component: NewCategoryModal,
});

function NewCategoryModal() {
  const navigate = useNavigate();
  const search = useSearch({ strict: false }) as {
    categoryParentId?: string;
    expandedCategories?: string;
  };

  // Fetch parent category to get flowType for inheritance
  const { data: parentCategory } = useCategoryDetail(search.categoryParentId);

  const handleClose = () => {
    navigate({
      to: `${PROTECTED}${SETTINGS}`,
      search: (old) => ({
        ...old,
        tab: 'category',
        subTab: 'list',
        categoryParentId: undefined,
      }),
    });
  };

  return (
    <CategoryForm
      modalOpen={true}
      parentId={search.categoryParentId}
      parentCategory={parentCategory}
      onModalClose={handleClose}
    />
  );
}
